import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { getStoredData } from "../../api/fetchData";
import EditFormComponent from "../../components/EditFormComponent/EditFormComponent";
import "./AllFormPage.css";

/** build an empty/default value for a field based on its config */
const getEmptyValue = (col) => {
  const t = (col.type || "").toLowerCase();

  // Arrays / multi-selects default to []
  if (col.multiple || col.array === "true" || t === "array") return [];

  // Booleans default to false
  if (t === "boolean") return false;

  // Numbers default to 0 so Mongo required passes
  if (t === "number") return 0;

  // Files default to [] if multiple, else ""
  if (t === "file") return col.array === "true" ? [] : "";

  // Dates/time default to ""
  if (t === "date" || t === "datetime" || t === "time") return "";

  // Dropdown/ObjectId default
  if (t === "dropdown" || t === "objectid" || t === "select") {
    return col.multiple ? [] : "";
  }

  // Fallback text
  return "";
};


const AllFormPage = () => {
  const { model } = useParams();
  const navigate = useNavigate();

  const [config, setConfig] = useState(null);
  const [fieldConfig, setFieldConfig] = useState([]);
  const [dropdownOptions, setDropdownOptions] = useState({});
  const [formData, setFormData] = useState({});
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const stored = await getStoredData();
        const allConfigs = stored["1"]?.tableConfigs || {};
        const modelConfig = allConfigs[model];

        if (!modelConfig) return;

        setConfig(modelConfig);
        setFieldConfig(modelConfig.columns || []);

        // 1) Prepare empty defaults from columns
        const defaults = {};
        (modelConfig.columns || []).forEach((col) => {
          // skip non-editable/display columns if your config has such flags
          defaults[col.field] = getEmptyValue(col);
        });
        setFormData(defaults);

        // 2) Preload dropdowns
        const dropdowns = {};
        await Promise.all(
          (modelConfig.columns || []).map(async (col) => {
            if (col.api) {
              const res = await axios.get(col.api);
              dropdowns[col.field] = res.data;
            }
          })
        );
        setDropdownOptions(dropdowns);
      } catch (err) {
        console.error("Failed to load config/options", err);
      }
    };

    load();
  }, [model]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    if (!config?.api) return;
    try {
      setSubmitting(true);
      // POST for create
      const res = await axios.post(config.api, formData);
      // If your API returns the created _id, you can navigate to edit or list
      // navigate(`/edit/${model}/${res.data?._id}`);
      // or go back to the model list:
      // navigate(`/table/${model}`);
      // For now, just alert success:
      alert("Created successfully");
      setSubmitting(false);
      navigate(`/table/${model}`);
    } catch (e) {
      console.error("Create failed", e);
      alert("Create failed. Check console for details.");
      setSubmitting(false);
    }
  };

  if (!config)
    return <div style={{ padding: 20 }}>Missing config for "{model}"</div>;

  return (
    <div className="edit-form-container" style={{ padding: 30 }}>
      {/* <h2 className="formHeaderTitle">{config.title} — Create</h2> */}

      <EditFormComponent
        mode="create" // optional: if you want to branch inside EditFormComponent
        fields={fieldConfig}
        formData={formData}
        dropdownOptions={dropdownOptions}
        onChange={handleChange}
        modelId={null} // signals “create”
        Put={config.api} // keep for compatibility; component can ignore for create
        file={config.uploadApi}
        model={model}
        onSubmit={handleSubmit} // let the page own the POST
        submitting={submitting} // optional: to show spinner/disable
      />
    </div>
  );
};

export default AllFormPage;
